var map = {
	"./bg.png": 25,
	"./flags/be.svg": 26,
	"./flags/cn.svg": 27,
	"./flags/de.svg": 28,
	"./flags/es.svg": 29,
	"./flags/fr.svg": 30,
	"./flags/gb.svg": 31,
	"./flags/it.svg": 32,
	"./flags/jp.svg": 33,
	"./flags/us.svg": 34,
	"./icons/arrow-top-right.svg": 35,
	"./icons/arrow.svg": 36,
	"./icons/back.svg": 37,
	"./icons/clock.svg": 38,
	"./icons/close.svg": 39,
	"./icons/email.svg": 40,
	"./icons/error.svg": 41,
	"./icons/facebook.svg": 42,
	"./icons/info.svg": 43,
	"./icons/instagram.svg": 44,
	"./icons/linkedin.svg": 45,
	"./icons/marker.svg": 46,
	"./icons/phone.svg": 47,
	"./icons/slider-arrow.svg": 48,
	"./icons/success.svg": 49,
	"./icons/tiktok.svg": 50,
	"./icons/twitter-x.svg": 51,
	"./icons/twitter.svg": 52,
	"./icons/weibo.svg": 53,
	"./icons/whatsapp.svg": 54,
	"./icons/youtube.svg": 55,
	"./logo-black.png": 56,
	"./logo.png": 57,
	"./square.svg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;